import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Switch, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { CardSettings } from '@application/models/score-card';
import { useDispatch, useSelector } from 'react-redux';
import { addScoreCriterion, removeScoreCriterion } from '@application/redux/scoreCard/score-card-slice';
const assetId = '86aac17d-397e-404f-9242-c4f1f2052b34';
const CriteriaForm = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [criteria, setCriteria] = useState({});
    const [isTimeSensitive, setIsTimeSensitive] = useState(false);
    const [hasTimeRange, setHasTimeRange] = useState(false);
    const [hasdistance, setHasDistance] = useState(false);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCriteria((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const { errorTitle, errorDescription } = useSelector((state) => state.scoreCardSlice);
    useEffect(() => { }, [errorTitle, errorDescription]);
    const handleBlur = (e) => {
        const { name, value } = e.target;
        if (value?.trim()) {
            const newCriterion = {
                assetId,
                hasMultipleValues: false,
                fieldAndValue: {
                    key: name,
                    value: value
                },
                isFieldEnabled: true
            };
            dispatch(addScoreCriterion(newCriterion));
        }
    };
    const createEmptyCriterion = (key) => {
        const newCriterion = {
            assetId,
            hasMultipleValues: false,
            fieldAndValue: {
                key,
                value: ''
            },
            isFieldEnabled: true
        };
        dispatch(addScoreCriterion(newCriterion));
    };
    return (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: 12, children: _jsx(TextField, { label: CardSettings.Title, fullWidth: true, name: 'title', value: criteria.title || '', onChange: handleInputChange, onBlur: handleBlur, 
                    // {...register('title')}
                    error: !!errorTitle, helperText: errorTitle }) }), _jsx(Grid, { size: 12, children: _jsx(TextField, { label: CardSettings.Description, fullWidth: true, name: 'description', value: criteria.description || '', onChange: handleInputChange, onBlur: handleBlur }) }), _jsx(Grid, { size: 12, children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: isTimeSensitive, onChange: (e) => setIsTimeSensitive(e.target.checked), value: isTimeSensitive, color: 'primary' }), label: CardSettings.TimeSensitivity }) }), _jsx(Grid, { size: 12, children: isTimeSensitive && (_jsx(TextField, { label: CardSettings.TimeSensitivity, fullWidth: true, name: 'timeSensitivityDescription', value: criteria.TimeSensitivity, onChange: handleInputChange, helperText: '', onBlur: handleBlur })) }), _jsx(Grid, { size: 12, children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: hasTimeRange, onChange: (e) => {
                            const checked = e.target.checked;
                            setHasTimeRange(checked);
                            if (checked)
                                createEmptyCriterion('timeRange');
                        }, color: 'primary' }), label: CardSettings.TimeRange }) }), _jsx(Grid, { size: 12, children: _jsx(FormControlLabel, { control: _jsx(Switch, { checked: hasdistance, onChange: (e) => {
                            const checked = e.target.checked;
                            setHasDistance(checked);
                            if (checked)
                                createEmptyCriterion('distance');
                            else {
                                dispatch(removeScoreCriterion({ key: 'distance' }));
                            }
                        }, color: 'primary' }), label: CardSettings.Distance }) })] }));
};
export default CriteriaForm;
